module.exports = __webpack_public_path__ + "img/schweinsschnitzel.2eac0c25.png";